import Wprr from "wprr";

import moment from "moment";

export default class ItemsSetup {
	
	static registerInProject(aProject) {
		aProject.items.addSetup("example", ItemsSetup.prepare_none, ItemsSetup.setup_example);
	}
	
	static prepare_none(aItem) {

	}

	static setup_none(aItem, aData) {
		
	}

	static setup_example(aItem, aData) {
		//aItem.addSingleLink("status", aData["status"]);
	}
	
}
